// @flow

import { cmsAxios } from '../axios-config';

const readNotifications = (notiifcationId, userId) => {
  return cmsAxios.put(`/notifications/${notiifcationId}/read?userId=${userId}`);
};

export default readNotifications;
